import script from "./BarChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./BarChart.vue?vue&type=script&setup=true&lang=ts"

import "./BarChart.vue?vue&type=style&index=0&id=842c627a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-842c627a"]])

export default __exports__